module.exports = __webpack_public_path__ + "static/media/steve-turks.0ca2e2e5.jpg";